import React, { useState, useEffect } from "react";
import Shell from "components/Shell";
import { getAll } from "api";
import { CAMPAIGN_NAMES, HEADERS } from "config";

const props = {
  adFormatName: CAMPAIGN_NAMES.INSURANCE,
  tableHeaders: HEADERS.INSURANCE,
};

export default () => {
  const [data, setData] = useState([]);

  const refresh = () => {
    getAll(CAMPAIGN_NAMES.INSURANCE.short)
      .then((data) => setData(data?.ads ?? []))
      .catch(console.log);
  };

  useEffect(() => {
    refresh();
  }, []);

  return <Shell {...props} campaignsData={data} refresh={refresh} />;
};
